import React from 'react';
import { Link } from 'react-router-dom';
import redPlusCircle from '../../assets/sprites/big_red_plus_circle.svg';

interface AddEntityProps {
  text: string;
  path?: string;
  state?: any;
  isLink?: boolean;
  onClick?: () => void;
}

const btnClass = 'flex items-center cursor-pointer min-h-[32px] justify-between w-fit p-0 font-semibold text-[14px] leading-[17px] text-[#404040] bg-transparent border-none hover:bg-transparent gap-2';

const AddEntity = ({ text, path = '/', state = {}, isLink = true, onClick = () => {} }: AddEntityProps): JSX.Element => {
  const content = (
    <>
      <img src={redPlusCircle} alt={`Добавить ${text}`} className="w-5 h-5" />
      Добавить {text}
    </>
  );

  if (!isLink) {
    return (
      <button className={btnClass} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <Link state={state} to={path} className={btnClass}>
      {content}
    </Link>
  );
};

export default AddEntity;
